import React from 'react';
import PropTypes from 'prop-types';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import styles from './ctaBlock.scss';

export const CtaBlock = ({ data }) => {
  const heading = getIn(data, 'fields', 'heading');
  const description = getIn(data, 'fields', 'description');
  const link = getIn(data, 'fields', 'link');
  const linkText = getIn(data, 'fields', 'linkText');

  const image = getIn(data, 'fields', 'image', 'fields');
  const imgUrl = getIn(image, 'file', 'url');
  const imgDesc = getIn(image, 'description');

  return (
    <div className={styles.wrapper}>
      <img
        className={styles.image}
        alt={imgDesc ? imgDesc : ''}
        src={`${imgUrl}?w=860&h=573&q=90&fm=webp`}
      />
      <div className={styles.text}>
        <h2>{heading}</h2>
        <p>{description}</p>
        <a href={link} aria-label={linkText} className={styleHelper.hlfLink}>
          {linkText}
        </a>
      </div>
    </div>
  );
};

CtaBlock.propTypes = {
  data: PropTypes.object.isRequired,
};
